import * as types from "../types/pedidos";
import dayjs from "dayjs";

const INITIAL_STATE = {
  loading: false,
  filtro: {
    data_inicio: dayjs().subtract(30, "days").format("YYYY-MM-DD"),
    data_final: dayjs().add(1, "day").format("YYYY-MM-DD"),
    status: [],
  },
  pedido: {},
  items_pedido: [],
  perpage: 10,
  page: 1,
  total: 0,
  pedidos: [],
  pedidos_qtde_status: {},
  entregadores: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_ITEMS:
      return { ...state, items_pedido: action.payload };
    case types.SET_QTDE_STATUS:
      return { ...state, pedidos_qtde_status: action.payload };
    case types.SET_LOADING:
      return { ...state, loading: action.payload };
    case types.SET_LIST:
      return { ...state, pedidos: action.payload };
    case types.SET_LOAD:
      return { ...state, pedido: action.payload };
    case types.SET_PAGE:
      return { ...state, page: action.payload };
    case types.SET_PERPAGE:
      return { ...state, perpage: action.payload };
    case types.SET_TOTAL:
      return { ...state, total: action.payload };
    case types.SET_ENTREGADORES:
      return { ...state, entregadores: action.payload };
    case types.SET_FILTER:
      return {
        ...state,
        filtro: { ...state.filtro, ...action.payload },
      };

    default:
      return state;
  }
};
